interface IError {
  msg?: string;
  el?: string;
}

export interface IErrorsStore {
  [key: string]: IError;
}

export const errorsStore = {};
